export default __webpack_public_path__ + "static/media/portfolio-54.e72913c7.jpg";